import React from 'react';
import { array, bool, string } from 'prop-types';
import { Container, Row } from 'reactstrap';

import NewsItem from '../NewsItem/NewsItem';

const propTypes = {
  id: string.isRequired,
  isMobile: bool.isRequired,
  newsData: array.isRequired
};

const NewsList = ({ id, isMobile, newsData }) => {
  const listClasses = isMobile
    ? 'pt-5 mt-5 w-100'
    : 'abs-container d-flex align-items-center';

  return (
    <div id={id} className={listClasses}>
      <Container className={'scrollable h-60'}>
        <Row>
          {newsData.map((item, index) => (
            <NewsItem key={index} index={index} isMobile={isMobile} {...item} />
          ))}
        </Row>
      </Container>
    </div>
  );
};

NewsList.propTypes = propTypes;

export default NewsList;



// WEBPACK FOOTER //
// ./src/components/News/NewsList/NewsList.jsx